import React, { useState } from "react";
import { Card, CardBody, Badge, Button, Spinner, Label } from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";
import TrainingVideoModal from "./TrainingVideoModal";

const TrainingVideoCard = ({ video, currency, onRefresh }) => {
  const [deleting, setDeleting] = useState(false);
  const [checking, setChecking] = useState(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  const openVideoModal = () => setShowVideoModal(true);
  const closeVideoModal = () => setShowVideoModal(false);

  const handleDelete = (e) => {
    e.stopPropagation();

    if (!window.confirm(`Delete training video for "${video.item_name}"?`)) {
      return;
    }

    setDeleting(true);

    postDataAPI({
      serviceName: "traning_video_data",
      op: "delete-training-video",
      video_id: video.video_id
    })
      .then((res) => {
        if (res.status === "ok") {
          onRefresh?.(); // refresh list
        } else {
          alert(res.message || "Failed to delete video");
        }
      })
      .finally(() => setDeleting(false));
  };

    const handleCheckStatus = (e) => {
    e.stopPropagation();

    if (checking) return;

    setChecking(true);

    postDataAPI({
      serviceName: "traning_video_data",
      op: "check-video-status",
      video_id: video.video_id,
      flash_card_id: video.flash_card_id
    })
      .then((res) => {
        if (res.status === "ok") {
          onRefresh?.(); // reuse refresh callback (better rename to onRefresh)
        } else {
          alert(res.message || "Failed to check video status");
        }
      })
      .finally(() => setChecking(false));
  };


  return (
    <Card className="h-100 shadow-sm">
      <CardBody>
        {/* Title */}
        <div className="d-flex justify-content-between align-items-start mb-1">
          <h6 className="fw-semibold mb-0">{video.item_name}</h6>

          <div className="d-flex gap-1">
            <Badge color="warning" pill>
              ⚡ Quick
            </Badge>

            <Badge color="success" pill>
              ✓ {video?.status}
            </Badge>

            <Badge color="light">
              <i
                className={`ri-delete-bin-line text-danger action-icon ${
                  deleting ? "opacity-50" : ""
                }`}
                title="Delete"
                onClick={handleDelete}
                style={{ cursor: "pointer" }}
              />
            </Badge>
          </div>
        </div>

        {/* Category + Price */}
        <div className="text-muted small mb-2">
          <Badge color="primary" pill className="me-1">
            {video?.course_name || ""}
          </Badge>
          {currency} {video.price}
        </div>

        {/* Video */}
        
          {video?.status === "Completed" &&
        
          <div
              style={{ cursor: "pointer", position: "relative" }}
              onClick={() => openVideoModal()}
            >
              <img
                src="/video-placeholder.jpeg"
                alt="Video thumbnail"
                style={{ width: "100%" }}
              />
              <span className="play-overlay">▶</span>
            </div>
         
          }
          {video?.status !== "Completed" &&
          <div className="ratio ratio-16x9 rounded overflow-hidden mb-2">
           <Label className="text-center mt-5">Generating Video...</Label>
           </div>
          }
        

        {/* Footer */}
        <div className="d-flex justify-content-between align-items-center small text-muted">
          <span>Created: {video.video_creation}</span>

          <div className="d-flex gap-1">
            {video?.status !== "Completed" &&
            <Button
              size="sm"
              outline
              title="Re-check status from Heygen"
              onClick={handleCheckStatus}
              disabled={checking}
            >
              {checking ? (
                <Spinner size="sm" />
              ) : (
                <i className="ri-refresh-line"></i>
              )}
            </Button>
            }

            {/* {video?.status === "Completed" &&
            <><Button size="sm" outline>
              🔗 Share
            </Button>
            <Button size="sm" outline>
              ⬇ Download
            </Button></>
            } */}
          </div>
        </div>

        {showVideoModal && (
            <TrainingVideoModal
            isOpen={showVideoModal}
            toggle={closeVideoModal}
            card={video}
          />
        )}
      </CardBody>
    </Card>
  );
};

export default TrainingVideoCard;
